import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import Newsletter from "../components/Newsletter";
import ServiceInnerDetails from "../components/ServiceInnerDetails";
import HeaderTwo from "../components/HeaderTwo";
import FooterThree from "../components/FooterThree";
import { AzureService } from "../data";



const ServiceDetails = ({data}) => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);
  return (
    <>

      {active === true && <Preloader />}

      <HelmetReact title={data?.title || "Service Details"} />

      <HeaderTwo />

      <Breadcrumb title={data?.title || "Service Details"} bg={data?.bannerImg || "/assets/img/bg/servicesbanner.png"}/>

      <ServiceInnerDetails servicedata={data ||  AzureService}/>

      <Newsletter />

      <FooterThree />

    </>
  );
};

export default ServiceDetails;
